/** DOM id of one entry's row — `?entry=:id` on the journal page scrolls to it. */
export const journalEntryElementId = (id: number) => `journal-entry-${id}`;
